function openPopup() {
    document.getElementById('popup-widget').style.display = 'flex';
    document.body.style.overflow = 'hidden'; // Disable scrolling
}

function closePopup() {
    document.getElementById('popup-widget').style.display = 'none';
    document.body.style.overflow = ''; // Re-enable scrolling
}